module.exports = __webpack_public_path__ + "static/img/kzhi.7de26ee.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/kzhi.png
// module id = AbR6
// module chunks = 2